import { render, staticRenderFns } from "./PlanEditPage.vue?vue&type=template&id=a5c3d4f4&"
import script from "./PlanEditPage.vue?vue&type=script&lang=ts&"
export * from "./PlanEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports